import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import moodleAxios from '../../../services/moodle/moodleApi';

export const fetchExerciseByCourseIdAsync = createAsyncThunk(
  'courses/fetchExerciseByCourseIdAsync',
  async url => {
    const res = await moodleAxios.get(url);
    return res.data;
  }
);

const exerciseSlice = createSlice({
  name: 'exercises',
  initialState: {
    exercises: JSON.parse(localStorage.getItem('exercises')) || {},
    load: false,
    error: false
  },
  reducers: {
    addExercise: (state, { payload }) => {
      const filteredExercises = payload.filter(item => item.modules.length > 0);
      state.exercises = filteredExercises;
      state.load = false;
      localStorage.setItem('exercises', JSON.stringify(filteredExercises));
    }
  },

  extraReducers: {
    [fetchExerciseByCourseIdAsync.pending]: state => {
      state.load = true;
    },
    [fetchExerciseByCourseIdAsync.fulfilled]: (state, { payload }) => {
      const filteredExercises = payload.filter(item => item.modules.length > 0);
      state.exercises = filteredExercises;
      state.load = false;
      localStorage.setItem('exercises', JSON.stringify(filteredExercises));
    },
    [fetchExerciseByCourseIdAsync.rejected]: (state, { payload }) => {
      state.error = payload;
      state.load = false;
    }
  }
});
export const getExerciseByCourseIdAsync = state => state.exercises.exercises;
export default exerciseSlice.reducer;
